<template>

  <div class="wrapper">
    <SiteHeader
      :user="user"
      :show-chrome="true"
      :nav-items="navItems"
      :active-section="activeSection"
      :is-header-scrolled="isHeaderScrolled"
      :is-menu-open="isMenuOpen"
      :upload-disabled="isUploadActionsDisabled"
      :promo-actions-disabled="isPromoActionsDisabled"
      :show-guest-upload-in-mobile="false"
      :show-guest-upload-on-desktop="false"
      @toggle-menu="toggleMenu"
      @close-menu="closeMenu"
      @nav-click="scrollToSection"
      @logo-click="redirectToHomePage('link')"
      @open-login="openCommonLoginPopup"
      @guest-upload="openCommonLoginPopup"
      @auth-upload="triggerQrScan"
      @account="redirectToPrivatePage"
      @logout="logout"
    />
    <main class="main" id="page-error">
      <div class="container">
        <h1 data-animate="fade-up">404</h1>
        <h2 data-animate="fade-up" data-animate-delay="100">Страница не найдена</h2>
        <h3 data-animate="fade-up" data-animate-delay="100">Проверьте адрес страницы — возможно, в нем закралась ошибка</h3>
        <button @click="redirectToHomePage('link')" class="button button-main" data-animate="fade-up" data-animate-delay="200">На главную</button>
      </div>
    </main>
  </div>

</template>


<script>
/* global ym */
/* global _txq */
import { getFeedbackTopics, fetchFAQ, getToken, getUserInfo, removeToken, authorize, register, getMainSettings, sendFeedback, setAuthHeader, sendResetPassword, fetchWinnings, formatApiErrorResponseMessage } from '@/api';
import metrikaMixin from '@/mixins/metrikaMixin';
import { state } from "@/store";
import { feedbackIdentityPrefill } from '@/utils/feedbackFormPrefill';
import {
  formatRussianMobileE164,
  isValidRussianMobilePhone,
  russianMobilePhoneHint,
} from '@/utils/russianMobilePhone';
import { registerNameSignificantLength } from '@/utils/registerPersonName';
import {onMounted, onUnmounted, ref} from "vue";
// import adRiver from '@/services/adriver';
import { hasCookieConsent } from '@/utils/cookieConsent';
import { ANALYTICS_DISABLED } from '@/config/analytics';
import { YANDEX_METRIKA_COUNTER_ID } from '@/utils/metrika';
import SiteHeader from '@/components/layout/SiteHeader.vue';
import { appRootKey } from '@/injectionKeys';
import { setMobileMenuScrollLock } from '@/utils/documentScrollLock';
import { blockIfPromoStatusPending, markPromoStatusLoaded } from '@/utils/promoStatus';
import { applyGameStatusFromMainSettings } from '@/utils/gameStatus';

export default {
  name: 'NotFound',
  mixins: [metrikaMixin],
  inject: {
    shell: {
      from: appRootKey,
      default: null,
    },
  },
  components: {
    SiteHeader,
  },
  setup() {
    const activeSection = ref('hero');
    const sections = ['how', 'prizes', 'winners', 'faq', 'contact'];
    const observer = new IntersectionObserver(
        (entries) => {
          let visibleSections = entries
              .filter((entry) => entry.isIntersecting)
              .map((entry) => entry.target.id);

          if (visibleSections.length > 0) {
            activeSection.value = visibleSections[0]; // Берем первую видимую секцию
          } else {
            activeSection.value = 'hero'; // Если ничего не видно — «Главная» (первый блок главной)
          }
        },
        { threshold: 0.5 }
    );

    onMounted(() => {
      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (el) observer.observe(el);
      });
    });

    onUnmounted(() => {
      observer.disconnect();
    });


    return {
      state,
      activeSection,
      navItems: [
        { id: 'hero', href: '/#hero', name: 'Главная' },
        { id: 'prizes', href: '/#prizes', name: 'Призы' },
        { id: 'interactive', href: '/#interactive', name: 'Интерактив' },
        { id: 'products', href: '/#products', name: 'Продукция' },
        { id: 'stores', href: '/#stores', name: 'Где купить' },
        { id: 'faq', href: '/#faq', name: 'Вопросы-ответы' },
      ],
    };
  },
  data() {
    return {
      winners: [],
      limit: 10,
      offset: 0,
      prizeType: '',
      userEmail: '',
      totalCount: 0,
      loading: false,
      prizeTypes: [
        { value: '', label: 'Все призы' },
        { value: 'grand', label: 'Главный' },
        { value: 'monthly', label: 'Ежемесячный' },
      ],
      noWinners: false,
      isMenuOpen: false,
      formSending: false,
      resetPasswordEmail: null,
      isOpen: false,
      selectedText: 'Тема обращения',
      topics: [],
      utmParams: {},
      clientId: null,
      hasMoreWinners: true,
      isLoading: false,
      activePrizeType: 1,
      isHeaderScrolled: false,
      scrollThreshold: 0,
      rootUrl: window.location.origin,
      userId: '',
      userUuid: '',
      isMobileNavOpened: false,
      faq: [],
      prizes: [],
      user: null,
      showLoginPopup: false,
      showCommonLoginPopup: false,
      showRegisterPopup: false,
      showRegisterPopupSuccess: false,
      showQuestionPopup: false,
      showQuestionPopupSuccess: false,
      showPromoNotStarted: false,
      showPromoEnd: false,
      showEndPopupSuccess: false,
      showResetPasswordPopup: false,
      showBalanceInfo: false,
      showResetPasswordSuccess: false,
      AccountPopup: false,
      questionForm: {
        name: this.user && this.user.first_name ? this.user.first_name : '',
        email: this.user && this.user.email ? this.user.email : '',
        text: '',
        agree_personal_data: false,
        agree_to_advertising: false,
        subject: '',
        files: []
      },
      filePreviews: [],
      phone_number: '',
      email: '',
      password: '',
      passwordVisible: false,
      registerForm: {
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        is_policy: false,
        agree_rules: false,
        agree_to_advertising: false
      },
      loginForm: {
        email: '',
        password: '',
      },
      loginFormErrors: {},
      resetPasswordForm: {
        email: '',
      },
      feedbackErrors: {},
      resetPasswordErrors: {},
      errors: {},
      responseError: '',
      registrationSuccessEmail: '',
      days: 0,
      hours: 0,
      minutes: 0,
      timerMessage: '',
      promoDates: '',
      mainSettings: {},
      isFocus: false,
      isChange: false,
      isGuarantedPopap: false,
    };
  },
  async created() {
    try {
      this.mainSettings = await getMainSettings();
    } catch (error) {
      console.error('Failed to fetch main settings', error);
    }
    this.loadFAQ();
    this.checkAuthentication();
    await this.fetchTimerData();
  },
  beforeUnmount() {
    setMobileMenuScrollLock(false);
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('click', this.handleDynamicButtonClick);
    document.body.classList.remove('is-upload-widget-opened');
  },
  async mounted() {
    // adRiver.trackPageView();
    this.loadWinners();
    this.initFloatingLabels();
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get("ref");
    if (ref) {
      state.ref = ref;
    }
    await this.fetchTopics();
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeydown);
    this.addIntersectionObserver();
    this.initScrollAnimations();
    this.getClientId();
    this.getUTMParams();
    this.handleScroll();
    // this.fetchWinners();
    // this.fetchPrizes();
    setAuthHeader();
    const token = getToken();
    if (token) {
      setTimeout(async () => {
        getUserInfo().then(userInfo => {
          if (userInfo) {
            this.userId = userInfo.id;
            this.userUuid = userInfo.uuid;
            this.user = {
              first_name: userInfo.first_name,
              last_name_initial: (userInfo.last_name || '').charAt(0),
              email: userInfo.email,
            };
            this.shell.questionForm.name = userInfo.first_name;
            this.shell.questionForm.email = userInfo.email;
            // this.initQrWidget();
          }
        }).catch(error => {
          console.error('Failed to fetch user info on mount', error);
        });
      }, 900); // 500 мс задержка
    }
    window.addEventListener('scroll', this.handleScroll);
    document.querySelectorAll(".guaranteed-card").forEach(card => {
      card.addEventListener("click", () => {
        if (card.classList.contains("active")) {
          card.classList.remove("active");
        } else {
          document.querySelectorAll(".guaranteed-card").forEach(el => el.classList.remove("active"));
          card.classList.add("active");
        }
      });
    });
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.classList.remove('is-upload-widget-opened');
  },
  computed: {
    isPromoActionsDisabled() {
      return !state.promoStatusLoaded;
    },
    isUploadActionsDisabled() {
      return !state.promoStatusLoaded || state.isUploadOpened;
    },
    rulesUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/rules`;
    },
    policyUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/policy`;
    },
    agreementUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/agreement`;
    },
    advertisingUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/advertising`;
    },
    cookieUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/cookie`;
    },
    settingsUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/settings`;
    },
    promoStartText() {
      const start = this.mainSettings?.start_date;
      if (!start) {
        return state.promoStart || '';
      }

      const startDate = new Date(start);
      if (Number.isNaN(startDate.getTime())) {
        return state.promoStart || '';
      }

      const formatter = new Intl.DateTimeFormat('ru-RU', {
        timeZone: 'Europe/Moscow',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });

      return `${formatter.format(startDate)} года`;
    },
    isQuestionFormValid() {
      if (!this.shell.questionForm.name || this.shell.questionForm.name.trim().length < 2) {
        return false;
      }
      if (!this.shell.questionForm.email || !this.isEmailStrictValid(this.shell.questionForm.email.trim())) {
        return false;
      }
      if (!this.shell.questionForm.subject || this.shell.questionForm.subject === 'Выберите тему') {
        return false;
      }
      const text = (this.shell.questionForm.text || '').trim();
      if (text.length < 2 || text.length > 600) {
        return false;
      }
      if (!this.shell.questionForm.agree_personal_data) {
        return false;
      }
      if (
        (this.shell.feedbackErrors.name && this.shell.feedbackErrors.name !== '') ||
        (this.shell.feedbackErrors.email && this.shell.feedbackErrors.email !== '') ||
        (this.shell.feedbackErrors.subject && this.shell.feedbackErrors.subject !== '') ||
        (this.shell.feedbackErrors.text && this.shell.feedbackErrors.text !== '') ||
        (this.shell.feedbackErrors.agree_personal_data && this.shell.feedbackErrors.agree_personal_data !== '')
      ) {
        return false;
      }
      return true;
    },
    isLoginFormValid() {
      const email = this.shell.email;
      const password = this.shell.password;
      
      if (!email || email.trim() === '') {
        return false;
      }
      
      // Строгая валидация email формата
      if (!this.isEmailStrictValid(email)) {
        return false;
      }
      
      if (!password || password.trim() === '') {
        return false;
      }

      if (password.length < 6) {
        return false;
      }
      
      // Проверяем, что нет ошибок валидации (пустая строка или undefined считаются отсутствием ошибки)
      return (!this.shell.loginFormErrors.email || this.shell.loginFormErrors.email === '') && 
             (!this.shell.loginFormErrors.password || this.shell.loginFormErrors.password === '');
    },
    isResetPasswordFormValid() {
      const email = this.shell.resetPasswordForm.email;
      if (!this.isEmailStrictValid(email)) {
        return false;
      }
      // Проверяем, что нет ошибки валидации (пустая строка или undefined считаются отсутствием ошибки)
      return !this.shell.resetPasswordErrors.email || this.shell.resetPasswordErrors.email === '';
    },
    isRegisterFormValid() {
      return (
        registerNameSignificantLength(this.shell.registerForm.first_name) >= 2 &&
        registerNameSignificantLength(this.shell.registerForm.last_name) >= 2 &&
        this.shell.registerForm.email.length > 0 &&
        this.isEmailStrictValid(this.shell.registerForm.email) &&
        isValidRussianMobilePhone(this.shell.registerForm.phone_number) &&
        this.shell.registerForm.agree_rules &&
        !this.shell.errors.first_name &&
        !this.shell.errors.last_name &&
        !this.shell.errors.email &&
        !this.shell.errors.phone_number
      );
    },
    formattedPhoneNumber() {
      // Убираем знак '+' и все нецифровые символы
      const cleaned = this.phoneNumber.replace(/\D/g, '');

      // Проверяем, что номер начинается с '7' и содержит 11 цифр
      if (cleaned.length === 11 && cleaned.startsWith('7')) {
        return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9, 11)}`;
      }

      return ' ';
    }
  },
  // mounted(){

  // },
  methods: {
    isEmailStrictValid(email) {
      const normalized = String(email || '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .trim();
      if (!normalized) {
        return false;
      }
      // Строгая проверка формата:
      // - основная часть начинается с буквы/цифры
      // - домен начинается с буквы/цифры
      // - допустимы только стандартные символы email
      const strictRegex = /^[A-Za-z0-9][A-Za-z0-9._%+-]*@[A-Za-z0-9][A-Za-z0-9.-]*\.[A-Za-z]{2,}$/;
      return strictRegex.test(normalized);
    },
    getFirstError(errorsObj) {
      if (!errorsObj || typeof errorsObj !== 'object') return '';
      const firstError = Object.values(errorsObj).find((value) => {
        if (typeof value === 'string') return value.trim() !== '';
        return Boolean(value);
      });
      return typeof firstError === 'string' ? firstError : '';
    },
    handleDynamicButtonClick(event) {
      if (event.target.id === 'apm-close-widget-button') {
        this.$sendMetrik('reachGoal', 'upload_check_closed');
        state.isUploadOpened = false;
        document.body.classList.remove('is-upload-widget-opened');
      }
    },
    async loadWinners(reset = false) {
      if (this.loading) return;
      this.loading = true;

      if (reset) {
        this.offset = 0;
        this.winners = [];
      }

      try {
        const data = await fetchWinnings({
          limit: this.limit,
          offset: this.offset,
          prize_type: this.prizeType,
          user_email: this.userEmail,
        });
        this.winners = reset ? data.results : [...this.winners, ...data.results];
        this.totalCount = data.count;
        this.offset += this.limit;
        this.noWinners = this.winners.length === 0;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      this.toggleBodyScroll();
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.toggleBodyScroll();
    },
    toggleBodyScroll() {
      setMobileMenuScrollLock(this.isMenuOpen);
    },
    async fetchTopics() {
      try {
        this.shell.topics = await getFeedbackTopics();
      } catch (error) {
        console.error('Error loading topics:', error);
      }
    },
    isOpenGuarantedPopap(){
    },
    toggleDropdown() {
      this.shell.isOpen = !this.shell.isOpen;
      this.$nextTick(() => {
        if (this.$refs.dropDownBtn && this.$refs.dropDownList) {
          this.$refs.dropDownList.style.top = `${this.$refs.dropDownBtn.offsetHeight}px`;
        }
      });
    },
    selectItem(item) {
      this.shell.selectedText = item.title;
      this.shell.questionForm.subject = item.id;
      this.shell.isOpen = false;
      this.shell.isChange = true;
    },
    handleClickOutside(event) {
      // Проверяем, что this.$refs.dropdown существует
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.shell.isOpen = false;
      }
    },
    handleKeydown(event) {
      if (event.key === 'Tab' || event.key === 'Escape') {
        this.shell.isOpen = false;
      }
    },
    getClientId() {
      // Проверяем согласие перед получением clientId
      if (!hasCookieConsent()) {
        return;
      }
      if (ANALYTICS_DISABLED) {
        return;
      }
      
      if (typeof ym !== 'undefined') {
        ym(YANDEX_METRIKA_COUNTER_ID, 'getClientID', (clientId) => {
          this.clientId = clientId;
          this.getUTMParams();
        });
      } else {
        console.error('Yandex.Metrica не доступна');
      }
    },
    // executeAdriverEvent(page) {
    //   const sidMapping = {
    //     rules_click: 'rules_click',
    //     go: 'go',
    //     signup_sentform_success: 'signup_sentform_success',
    //     check_download_success: 'check_download_success',
    //   };
    //
    //   if (!sidMapping[page]) return;
    //
    //   const sid = 230164; // ваш статический sid
    //   const bt = 62; // ваш статический bt
    //   const sz = sidMapping[page];
    //
    //   // Вызов Adriver-кода
    //   (function (e, n) {
    //     function o(e, n, o) {
    //       n = n || "&";
    //       o = o || "=";
    //       var d = [];
    //       for (var r in e)
    //         if (Object.prototype.hasOwnProperty.call(e, r)) {
    //           d.push(r + o + encodeURIComponent(e[r]));
    //         }
    //       return d.join(n);
    //     }
    //     function d(e, n) {
    //       var o = e.cookie.match("(^|;) ?" + n + "=([^;]*)(;|$)");
    //       return o ? decodeURIComponent(o[2]) : null;
    //     }
    //     var r,
    //         t,
    //         i,
    //         c,
    //         u;
    //     (r = e),
    //         (t = n),
    //         (i = document.domain),
    //         (c = { tail256: document.referrer || "unknown" }),
    //     void 0 !==
    //     (u = (function (e) {
    //       var n = {};
    //       if (e) {
    //         var o = e.split("&");
    //         for (var d in o)
    //           if (Object.prototype.hasOwnProperty.call(o, d)) {
    //             var r = o[d].split("=");
    //             void 0 !== r[0] &&
    //             void 0 !== r[1] &&
    //             (n[r[0]] = decodeURIComponent(r[1]));
    //           }
    //       }
    //       return n;
    //     })(window.location.search.substring(1))).adrclid && (r.fsid = u.adrclid),
    //     null !== d(document, "adrcid") && (r.cid = d(document, "adrcid")),
    //     t &&
    //     t.id &&
    //     null !== d(document, t.id) &&
    //     (r.suid = i + "_" + encodeURIComponent(d(document, t.id))),
    //         t && t.gid1
    //             ? (r.gid1 = t.gid1)
    //             : null !== d(document, "_ga") &&
    //             (r.gid1 = encodeURIComponent(d(document, "_ga"))),
    //         t && t.yid1
    //             ? (r.yid1 = t.yid1)
    //             : null !== d(document, "_ym_uid") &&
    //             (r.yid1 = encodeURIComponent(d(document, "_ym_uid"))),
    //         (r.loc = encodeURIComponent(window.location.href)),
    //     r.custom && (r.custom = o(r.custom, ";")),
    //         (function (e, n) {
    //           !(function (e) {
    //             if (
    //                 ((e = e.split("![rnd]").join(~~(1e6 * Math.random()))),
    //                 document.createElement && document.body)
    //             ) {
    //               var n = document.createElement("img");
    //               (n.style.position = "absolute"),
    //                   (n.style.display = "none"),
    //                   (n.style.width = n.style.height = "0px"),
    //                   n.setAttribute("referrerpolicy", "no-referrer-when-downgrade"),
    //                   (n.src = e),
    //                   document.body.appendChild(n);
    //             } else {
    //               var o = new Image();
    //               o.setAttribute("referrerpolicy", "no-referrer-when-downgrade"),
    //                   (o.src = e);
    //             }
    //           })(
    //               "https://ad.adriver.ru/cgi-bin/rle.cgi?" +
    //               e +
    //               "&rnd=![rnd]" +
    //               (n ? "&" + n : "")
    //           );
    //         })(o(r), o(c));
    //   })({ sid: sid, bt: bt, sz: sz }, { id: "", gid1: "", yid1: "" });
    // },
    addIntersectionObserver() {
      const options = {
        root: null, // используется viewport
        threshold: 0.10, // элемент должен быть виден на 25%
      };

      const observer = new IntersectionObserver(this.handleIntersection, options);

      // Находим все элементы с классом .js-animate-section
      const sections = document.querySelectorAll('.js-animate-section');

      // Наблюдаем за каждым элементом
      sections.forEach(section => {
        observer.observe(section);
      });
    },
    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-animated');
        }
      });
    },
    initScrollAnimations() {
      // Инициализируем анимации при скролле
      this.$nextTick(() => {
        const observerOptions = {
          root: null,
          rootMargin: '0px 0px 200px 0px',
          threshold: 0.01
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-animated');
              observer.unobserve(entry.target);
            }
          });
        }, observerOptions);

        const animatedElements = document.querySelectorAll('[data-animate]');
        animatedElements.forEach(el => {
          const animationType = el.getAttribute('data-animate');
          const delay = el.getAttribute('data-animate-delay') || '0';
          
          el.classList.add('animate-on-scroll', `animate-${animationType}`);
          
          // Устанавливаем задержку
          if (delay !== '0') {
            const delayNum = parseInt(delay, 10);
            // Если задержка в стандартных значениях (100, 200, 300, 400, 500), используем класс
            if ([100, 200, 300, 400, 500].includes(delayNum)) {
              el.classList.add(`animate-delay-${delay}`);
            } else {
              // Для других значений используем inline style
              el.style.transitionDelay = `${delayNum / 1000}s`;
            }
          }
          
          observer.observe(el);
        });
      });
    },
    getUTMParams() {
      const params = new URLSearchParams(window.location.search);
      const utmParams = {
        utm_source: params.get('utm_source'),
        utm_medium: params.get('utm_medium'),
        utm_campaign: params.get('utm_campaign'),
        utm_term: params.get('utm_term'),
        utm_content: params.get('utm_content'),
        click_id: params.get('click_id')
      };

      // Фильтрация null значений
      const filteredParams = Object.fromEntries(
          Object.entries(utmParams).filter(([, value]) => value !== null)
      );

      // Если есть UTM параметры, сохраняем их в localStorage
      if (Object.keys(filteredParams).length > 0) {
        const paramsString = new URLSearchParams(filteredParams).toString();
        localStorage.setItem('registration_params', paramsString);
        this.utmParams = filteredParams;
      } else {
        // Если нет параметров в URL, пытаемся загрузить из localStorage
        const savedParams = localStorage.getItem('registration_params');
        if (savedParams) {
          const savedParamsObj = Object.fromEntries(new URLSearchParams(savedParams));
          this.utmParams = savedParamsObj;
        } else {
          this.utmParams = {};
        }
      }

      // Добавляем clientId в utmParams после его получения
      if (this.clientId) {
        this.utmParams.client_id = this.clientId;
      }
    },
    handleFileChange(event) {
      const files = Array.from(event.target.files);

      this.shell.responseError = '';

      // Фильтрация по разрешённым типам файлов и размеру
      const MAX_SIZE = 5 * 1024 * 1024; // 5 MB
      let hasOversize = false;

      const validFiles = files.filter(file => {
        const isValidType = /\.(jpg|jpeg|png|gif|tiff|webp|pdf)$/i.test(file.name);
        const isValidSize = file.size <= MAX_SIZE;
        if (!isValidSize) {
          hasOversize = true;
        }
        return isValidType && isValidSize;
      });

      if (hasOversize) {
        this.shell.responseError = 'Максимальный размер: 5MB';
      }

      const MAX_FEEDBACK_FILES = 10;
      const slotsLeft = Math.max(0, MAX_FEEDBACK_FILES - this.shell.filePreviews.length);
      if (slotsLeft === 0) {
        this.shell.responseError = 'Прикреплено максимальное количество файлов';
        event.target.value = '';
        return;
      }
      const filesToAdd =
        validFiles.length > slotsLeft ? validFiles.slice(0, slotsLeft) : validFiles;

      // Добавляем файлы в состояние и показываем их превью
      filesToAdd.forEach(file => {
        const preview = {
          file,
          name: file.name,
          type: file.type,
          preview: URL.createObjectURL(file) // для изображений
        };
        this.shell.filePreviews.push(preview);
        this.shell.questionForm.files.push(file);
      });
      event.target.value = '';
    },

    // Удаление файла
    removeFile(index) {
      // Удаляем файл из массива файлов
      this.shell.filePreviews.splice(index, 1);
      this.shell.questionForm.files.splice(index, 1);
    },
    handleRulesButtonClick() {
      // this.executeAdriverEvent('rules_click');
      this.$sendMetrik('reachGoal', 'Rules_Click');
    },
    addBodyClass() {
      document.body.classList.add('is-popup-opened');
    },
    removeBodyClass() {
      document.body.classList.remove('is-popup-opened');
    },
    async logout() {
      state.checkSoon = false;
      state.checksTotal = 0;
      state.checks = {
        count: 0,
        next: null,
        previous: null,
        results: [],
      };
      state.user = {
        address: {
          apartment: null,
          city: null,
          email: null,
          fio: null,
          house: null,
          phone_number: null,
          street: null,
          zip_code: null,
        },

        first_name: null,
        last_name: null,
        phone_number: null,
        email: null,
        gender: null,
        is_verification: null,
        birthday: null,
        id: null,
        uuid: null,
        is_possible_to_upload_receipt: null,
        address_is_filled: null,
        promocode: null,
        referral_id: null,
        referral_link: null,
        balance: null,
        privilege_level: null,
        need_points: null,
        checks_count: 0,
        approved_checks_count: 0,
        rejected_checks_count: 0,
        all_cash: 0
      };
      const widget = document.getElementById('apm-widget');
      if (widget) {
        widget.innerHTML = ''; // Очистка содержимого виджета
      }

      this.toggleMobileNav(); // Логика для переключения навигации
      removeToken(); // Удаление токена (например, из localStorage)
      this.user = null; // Обновление состояния пользователя
      this.shell.questionForm = { // Очистка формы
        name: '',
        email: '',
        text: '',
        agree_personal_data: false,
        agree_to_advertising: false,
        subject: '',
        files: []
      };

      // Ожидание завершения обновления DOM
      await this.$nextTick();

      // Выполняем перенаправление после обновления DOM
      window.location.href = '/';
    },
    togglePasswordVisibility() {
      this.shell.passwordVisible = !this.shell.passwordVisible;
    },
    formatText(text) {
      // Замена переносов строк на <br>
      let formattedText = text.replace(/\r?\n/g, '<br>');

      // Регулярное выражение для поиска URL, которые НЕ находятся внутри <a> тегов
      const urlPattern = /(?<!<a href=")(https?:\/\/[^\s]+)(?!")/g;

      // Замена URL на HTML-ссылки
      formattedText = formattedText.replace(urlPattern, '<a href="$1" target="_blank">$1</a>');

      return formattedText;
    },
    clearError(field) {
      this.shell.errors = { ...this.shell.errors, [field]: null };
    },
    clearFeedbackError(field) {
      if (!this.shell.feedbackErrors) {
        this.shell.feedbackErrors = {};
      }
      this.shell.feedbackErrors[field] = '';
    },
    redirectToPrivatePage() {
      this.$router.push('/private');
      this.isMobileNavOpened = false;
    },
    redirectToHomePage() {
      this.$router.push('/');
    },
    removeSpacesFirstName() {
      const input = event.target.value.trimStart();
      this.shell.registerForm.first_name = input.length > 0 ? input : '';
    },
    removeSpacesLastName() {
      const input = event.target.value.trimStart();
      this.shell.registerForm.last_name = input.length > 0 ? input : '';
    },
    removeSpacesName() {
      const input = event.target.value.trimStart();
      this.shell.questionForm.name = input.length > 0 ? input : '';
    },
    initFloatingLabels() {
      this.$nextTick(() => {
        const floatingFields = document.querySelectorAll('.field-item--floating:not([data-floating-initialized])');
        floatingFields.forEach(fieldItem => {
          const input = fieldItem.querySelector('input, textarea');
          if (!input) return;

          // Помечаем как инициализированное
          fieldItem.setAttribute('data-floating-initialized', 'true');

          // Функция для проверки и обновления состояния
          const updateFloatingState = () => {
            const hasValue = input.value && input.value.trim() !== '';
            const hasFocus = document.activeElement === input;
            
            if (hasValue || hasFocus) {
              fieldItem.classList.add('field-item--active');
            } else {
              fieldItem.classList.remove('field-item--active');
            }
          };

          // Добавляем обработчики
          input.addEventListener('focus', updateFloatingState);
          input.addEventListener('blur', updateFloatingState);
          input.addEventListener('input', updateFloatingState);
          
          // Проверяем начальное состояние (без учета фокуса для iOS)
          const hasValue = input.value && input.value.trim() !== '';
          if (hasValue) {
            fieldItem.classList.add('field-item--active');
          } else {
            fieldItem.classList.remove('field-item--active');
          }
        });
      });
    },
    formatBirthdayInput(event) {
      let value = event.target.value.replace(/\D/g, ''); // Оставляем только цифры

      // Ограничиваем длину до 8 символов
      if (value.length > 8) {
        value = value.slice(0, 8);
      }

      // Форматируем строку в DD-MM-YYYY
      let formattedValue = value;

      if (value.length >= 2) {
        formattedValue = value.slice(0, 2) + '-' + value.slice(2); // Добавляем дефис после двух первых цифр
      }
      if (value.length >= 5) {
        formattedValue = formattedValue.slice(0, 5) + '-' + formattedValue.slice(5); // Добавляем дефис после пяти символов
      }

      // Удаляем дефис, если длина строки меньше 5 или 2
      if (formattedValue.length < 5) {
        formattedValue = formattedValue.replace('-', '');
      }

      if (formattedValue.length < 2) {
        formattedValue = formattedValue.replace('-', '');
      }

      // Присваиваем форматированное значение в форму
      this.shell.registerForm.birthday = formattedValue;
    },
    convertBirthdayFormat(date) {
      if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
        const [day, month, year] = date.split('-');
        return `${year}-${month}-${day}`;
      }
      return date;
    },
    triggerQrScan() {
      this.$sendMetrik('reachGoal', 'Check_Click');
      // this.executeDSPCounterEvent('buttons_click');
      if (state.promoStatus == 'start') {
        const qrElement = document.getElementById('apm-scan-qr');
        if (qrElement) {
          state.isUploadOpened = true;
          document.body.classList.add('is-upload-widget-opened');
          qrElement.click();
        }
      } else if (state.promoStatus == 'not-started') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.showPromoNotStarted = true;
      } else if (state.promoStatus == 'end') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.showPromoEnd = true;
      }
    },
    triggerQuestionForm() {
      const qrElement = document.getElementById('triggerQuestionForm');
      if (qrElement) {
        qrElement.click();
      }
    },
    toggleMobileNav() {
      this.isMobileNavOpened = !this.isMobileNavOpened;
    },
    handleLinkClick(selector) {
      this.toggleMobileNav(); // Закрываем навигацию
      // Убираем символ "#" из selector перед отправкой в SendMetrick
      // const cleanSelector = selector.replace('#', '');
      // this.SendMetrick(cleanSelector);

      setTimeout(() => { // Добавляем небольшую задержку перед скроллом
        this.scrollToSection(selector);
      }, 300); // Задержка в 300 мс или на ваше усмотрение
    },
    scrollToSection(selector) {
      // Убираем # из начала, если есть
      const cleanSectionId = selector.replace('#', '');
      
      // Проверяем, находимся ли мы на главной странице
      if (this.$route.path !== '/') {
        // Если не на главной, переходим на главную с хешем
        this.$router.push(`/#${cleanSectionId}`).then(() => {
          // HomePage.vue обработает хеш автоматически через watch
        });
        return;
      }
      
      // Если на главной странице, просто скроллим
      const target = document.querySelector(selector);
      if (target) {
        const offsetTop = target.getBoundingClientRect().top + window.pageYOffset - 50;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    },
    openAccountPopup() {
      this.addBodyClass();
      this.AccountPopup = true;
    },
    closeAccountPopup() {
      this.removeBodyClass();
      this.AccountPopup = false;
    },
    openQuestionPopup() {
      this.addBodyClass();
      this.shell.showQuestionPopup = true;
      this.shell.responseError = '';
      const fb = feedbackIdentityPrefill(this.user);
      this.shell.questionForm.name = fb.name;
      this.shell.questionForm.email = fb.email;
      this.$nextTick(() => {
        this.initFloatingLabels();
      });
    },
    closeQuestionPopup() {
      this.removeBodyClass();
      this.shell.showQuestionPopup = false;
      this.shell.responseError = '';
      this.resetForm();
      this.shell.filePreviews = [];
      this.shell.questionForm.files = [];
    },
    openQuestionPopupSuccess() {
      // adRiver.trackQuestionFormSubmit()
      this.$sendMetrik('reachGoal', 'Feedback_SentForm_Success');
      this.addBodyClass();
      this.shell.showQuestionPopupSuccess = true;
      this.resetForm();
    },
    closeQuestionPopupSuccess() {
      this.removeBodyClass();
      this.shell.showQuestionPopupSuccess = false;
      this.resetForm();
    },
    closeEndPopupSuccess() {
      this.removeBodyClass();
      this.showEndPopupSuccess = false;
      this.resetForm();
    },
    openResetPasswordPopup() {
      if (state.promoStatus == 'not-started') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.responseError = '';
        this.shell.showPromoNotStarted = true;
        return;
      }
      this.shell.resetPasswordForm.email = '';
      this.shell.resetPasswordErrors = {};
      this.shell.responseError = '';
      this.shell.showResetPasswordPopup = true;
      this.closeLoginPopup();
      this.addBodyClass();
      this.$nextTick(() => {
        this.initFloatingLabels();
      });
    },
    closeResetPasswordPopup() {
      this.removeBodyClass();
      this.shell.showResetPasswordPopup = false;
      this.resetForm();
    },
    openBalanceInfoPopup() {
      this.showBalanceInfo = true;
      this.closeLoginPopup();
      this.addBodyClass();
    },
    closeBalanceInfoPopup() {
      this.removeBodyClass();
      this.showBalanceInfo = false;
      this.resetForm();
    },
    goBalanceClick() {
      this.removeBodyClass();
      this.showBalanceInfo = false;
      this.resetForm();
      if (state.user.first_name) {
        this.triggerQrScan();
      } else {
        this.openLoginPopup()
      }
    },
    openResetPasswordPopupSuccess() {
      this.addBodyClass();
      this.shell.showResetPasswordSuccess = true;
    },
    closeResetPasswordPopupSuccess() {
      this.shell.resetPasswordEmail = null;
      this.removeBodyClass();
      this.shell.showResetPasswordSuccess = false;
      this.resetForm();
    },
    closeShowPromoNotStarted() {
      this.removeBodyClass();
      this.shell.showPromoNotStarted = false;
    },
    closeShowPromoEnd() {
      this.removeBodyClass();
      this.shell.showPromoEnd = false;
    },
    async submitQuestion() {
      try {
        this.shell.formSending = true;
        this.shell.feedbackErrors = {};

        // Валидация формы
        if (!this.shell.questionForm.name || this.shell.questionForm.name.trim().length < 2) {
          this.shell.feedbackErrors.name = 'Введите имя (минимум 2 символа)';
        }
        if (!this.shell.questionForm.email || !this.shell.questionForm.email.trim()) {
          this.shell.feedbackErrors.email = 'Поле обязательно для заполнения';
        } else if (!this.isEmailStrictValid(this.shell.questionForm.email)) {
          this.shell.feedbackErrors.email = 'Введите корректный email';
        }
        const textTrimmed = (this.shell.questionForm.text || '').trim();
        if (!textTrimmed) {
          this.shell.feedbackErrors.text = 'Введите Сообщение';
        } else if (textTrimmed.length < 2) {
          this.shell.feedbackErrors.text = 'Поле обязательно для заполнения';
        } else if (textTrimmed.length > 600) {
          this.shell.feedbackErrors.text = 'Текст обращения не более 600 символов';
        }
        if (!this.shell.questionForm.agree_personal_data) {
          this.shell.feedbackErrors.agree_personal_data = 'Необходимо согласиться на обработку персональных данных';
        } else {
          // Удаляем ошибку, если чекбокс отмечен
          delete this.shell.feedbackErrors.agree_personal_data;
        }
        if (!this.shell.questionForm.subject || this.shell.questionForm.subject === 'Выберите тему') {
          this.shell.feedbackErrors.subject = 'Выберите тему';
        }

        // Проверяем наличие ошибок (только непустые значения)
        const hasErrors = Object.keys(this.shell.feedbackErrors).some(key => this.shell.feedbackErrors[key] && this.shell.feedbackErrors[key] !== '');
        if (hasErrors) {
          this.shell.formSending = false;
          return;
        }

        // Отправка данных формы через API
        await sendFeedback({
          email: this.shell.questionForm.email,
          name: this.shell.questionForm.name,
          text: this.shell.questionForm.text,
          subject: this.shell.questionForm.subject,
          agree_personal_data: this.shell.questionForm.agree_personal_data,
          agree_to_advertising: this.shell.questionForm.agree_to_advertising,
          files: this.shell.questionForm.files // отправляем файлы
        });

        this.closeQuestionPopup();
        this.openQuestionPopupSuccess();
        this.shell.formSending = false;
      } catch (error) {
        this.shell.formSending = false;
        if (error.response && error.response.data) {
          this.shell.responseError = error.response.data.detail;
        }
      }
    },
    validateResetPasswordEmail() {
      const email = this.shell.resetPasswordForm.email;
      
      if (!this.shell.resetPasswordErrors) {
        this.shell.resetPasswordErrors = {};
      }
      
      if (!email || email.trim() === '') {
        this.shell.resetPasswordErrors.email = 'Поле обязательно для заполнения';
        return;
      }
      
      // Строгая валидация email
      if (!this.isEmailStrictValid(email)) {
        this.shell.resetPasswordErrors.email = 'Введите корректный email';
        return;
      }
      
      // Если все проверки пройдены, очищаем ошибку
      this.shell.resetPasswordErrors.email = '';
    },
    async submitResetPassword() {
      try {
        this.shell.formSending = true;
        const { email } = this.shell.resetPasswordForm;
        this.shell.resetPasswordErrors = {};
        this.shell.responseError = '';

        // Валидация email
        this.validateResetPasswordEmail();
        
        // Если есть ошибки валидации - не отправляем
        if (this.shell.resetPasswordErrors.email) {
          this.shell.formSending = false;
          return;
        }

        // Отправка данных формы через API
        await sendResetPassword({ email: email });

        // Успешная отправка, здесь можно закрыть попап
        this.shell.resetPasswordEmail = email;
        this.closeResetPasswordPopup();
        this.openResetPasswordPopupSuccess();
        this.shell.formSending = false;
      } catch (error) {
        this.shell.formSending = false;
        if (error.response && error.response.data) {
          this.shell.responseError = error.response.data.detail;
        }
      }
    },
    resetForm() {
      this.shell.formSending = false;
      this.shell.responseError = '';
      this.shell.errors = {};
      this.shell.loginFormErrors = {};
      this.shell.feedbackErrors = {};
      this.shell.resetPasswordErrors = {};
      this.shell.filePreviews = [];
      const fb = feedbackIdentityPrefill(this.user);
      this.shell.questionForm = {
        name: fb.name,
        email: fb.email,
        text: '',
        subject: '',
        agree_personal_data: false,
        files: []
      };

      this.phone_number = '';
      this.shell.password = '';

      this.shell.registerForm = {
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        is_policy: false,
        agree_rules: false,
        agree_to_advertising: false
      };

      this.shell.resetPasswordForm = {
        email: '',
      };
    },
    toggleAccordion(event) {
      // this.executeDSPCounterEvent('faq_click');
      event.target.classList.toggle('active');
      const textBlock = event.target.nextElementSibling;
      textBlock.classList.toggle('active');
    },
    handleScroll() {
      this.isHeaderScrolled = window.scrollY > this.scrollThreshold;
    },
    async checkAuthentication() {
      const token = getToken();
      if (token) {
        try {
          const userInfo = await getUserInfo();
          this.user = userInfo;
          state.user = {
            address: {
              apartment: userInfo.address?.apartment ?? "",
              city: userInfo.address?.city ?? "",
              email: userInfo.address?.email ?? "",
              fio: userInfo.address?.fio ?? "",
              house: userInfo.address?.house ?? "",
              phone_number: userInfo.address?.phone_number ?? "",
              street: userInfo.address?.street ?? "",
              zip_code: userInfo.address?.zip_code ?? "",
            },

            id: userInfo.id,
            uuid: userInfo.uuid,
            first_name: userInfo.first_name,
            last_name: userInfo.last_name,
            phone_number: userInfo.phone_number,
            email: userInfo.email,
            gender: userInfo.gender ?? null,
            is_verification: userInfo.is_verification ?? null,
            birthday: userInfo.birthday,
            is_possible_to_upload_receipt: userInfo.is_possible_to_upload_receipt,
            address_is_filled: userInfo.address_is_filled,
            promocode: userInfo.promocode,
            referral_id: userInfo.referral_id,
            referral_link: userInfo.referral_link,
            balance: userInfo.balance,
            privilege_level: userInfo.privilege_level,
            need_points: userInfo.need_points,
            checks_count: userInfo.checks_count,
            approved_checks_count: userInfo.approved_checks_count,
            rejected_checks_count: userInfo.rejected_checks_count,
            all_cash: userInfo.all_cash
          }
          // this.executeDSPCounterEvent('login_success');
          // this.shell.questionForm.name = userInfo.first_name;
          // this.shell.questionForm.email = userInfo.email;
        } catch (error) {
          if (error.response && error.response.data) {
            this.shell.responseError = error.response.data.detail;
          }
        }
      }
    },
    formatDateRange(start_date, end_date) {
      const start = new Date(start_date);
      const end = new Date(end_date);

      const format = (date) =>
          String(date.getUTCDate()).padStart(2, "0") + "." +
          String(date.getUTCMonth() + 1).padStart(2, "0") + "." +
          date.getUTCFullYear();

      return `${format(start)} – ${format(end)}`;
    },
    formatDateStart(start_date) {
      const start = new Date(start_date);

      return String(start.getUTCDate()).padStart(2, "0") + "." +
          String(start.getUTCMonth() + 1).padStart(2, "0") + "." +
          start.getUTCFullYear();
    },
    formatDateEnd(end_date) {
      const end = new Date(end_date);

      return String(end.getUTCDate()).padStart(2, "0") + "." +
          String(end.getUTCMonth() + 1).padStart(2, "0") + "." +
          end.getUTCFullYear();
    },
    async fetchTimerData() {
      try {
        const { start_date, end_date, status, game } = await getMainSettings();
        applyGameStatusFromMainSettings({ game, status, start_date, end_date });
        const now = new Date();
        const startDate = new Date(start_date);
        const endDate = new Date(end_date);
        const mappedStatus = status === 'future'
          ? 'not-started'
          : status === 'active'
            ? 'start'
            : status === 'past'
              ? 'end'
              : '';

        if (now >= endDate || mappedStatus === 'end') {
          this.days = 0;
          this.hours = 0;
          this.minutes = 0;
          this.timerMessage = 'Акция завершилась';
          this.promoDates = startDate + ' - ' + end_date;
          state.promoStatus = 'end'
          state.promoEnd = this.formatDateEnd(end_date);
        } else if (now < startDate || mappedStatus === 'not-started') {
          this.calculateTimeDifference(now, startDate);
          this.timerMessage = 'до начала акции';
          this.promoDates = start_date + ' - ' + end_date;
          state.promoStatus = 'not-started'
          state.promoStart = start_date;
          state.promoStart = this.formatDateStart(start_date);
        } else if (mappedStatus === 'start' || (!mappedStatus && now >= startDate && now < endDate)) {
          this.calculateTimeDifference(now, endDate);
          this.timerMessage = 'До окончания приема чеков';
          this.promoDates = start_date + ' - ' + end_date;
          state.promoStatus = 'start'
        } else {
          this.days = 0;
          this.hours = 0;
          this.minutes = 0;
          this.timerMessage = 'Акция завершилась';
          this.promoDates = startDate + ' - ' + end_date;
          state.promoStatus = 'end'
          state.promoEnd = this.formatDateEnd(end_date);
        }
        this.promoDates = this.formatDateRange(start_date, end_date);

        const promoShown = sessionStorage.getItem('promoShown');
        if (!promoShown && state.promoStatus === 'end') {
          this.shell.showPromoEnd = true;
          sessionStorage.setItem('promoShown', 'true');
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.shell.responseError = error.response.data.detail;
        }
      } finally {
        markPromoStatusLoaded();
      }
    },
    calculateTimeDifference(start, end) {
      const diff = end - start;

      // Переводим разницу в миллисекундах в дни, часы и минуты
      const totalSeconds = Math.floor(diff / 1000);
      this.days = Math.floor(totalSeconds / (3600 * 24));
      this.hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
      this.minutes = Math.floor((totalSeconds % 3600) / 60);
    },
    handleParticipateButton() {
      if (blockIfPromoStatusPending()) return;
      this.$sendMetrik('reachGoal', 'Go');
      this.openLoginPopup();
    },
    openLoginPopup() {
      if (blockIfPromoStatusPending()) return;
      this.shell.email = '';
      this.shell.password = '';
      this.shell.loginFormErrors = {};
      this.shell.responseError = '';
      this.shell.showCommonLoginPopup = false;
      state.showCommonLoginPopup = false;
      if (state.promoStatus == 'start' || state.promoStatus == 'end' || this.isPastMainSettingsEndDate()) {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.showLoginPopup = true;
        this.$nextTick(() => {
          this.initFloatingLabels();
        });
      } else if (state.promoStatus == 'not-started' || state.promoStatus == 'future') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.responseError = '';
        this.shell.showPromoNotStarted = true;
      }
    },
    closeLoginPopup() {
      if (typeof _txq !== 'undefined') {
        _txq.push(['track', 'enter_сancel']);
      }
      this.removeBodyClass();
      this.shell.showLoginPopup = false;
      this.shell.responseError = '';
      this.resetForm();
    },
    closeCommonLoginPopup() {
      this.shell.showCommonLoginPopup = false;
      state.showCommonLoginPopup = false;
      this.removeBodyClass();
      this.shell.responseError = '';
      this.resetForm();
    },
    openRegisterPopup() {
      if (this.shell?.openRegisterPopup) {
        this.shell.openRegisterPopup();
      }
    },
    isPastMainSettingsEndDate() {
      const raw = this.mainSettings?.end_date;
      if (!raw) return false;
      const t = new Date(raw).getTime();
      return !Number.isNaN(t) && Date.now() >= t;
    },
    openCommonLoginPopup() {
      if (blockIfPromoStatusPending()) return;
      this.shell.responseError = '';
      if (state.promoStatus == 'not-started' || state.promoStatus == 'future') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.showPromoNotStarted = true;
        return;
      }
      this.shell.showCommonLoginPopup = true;
      state.showCommonLoginPopup = true;
      this.addBodyClass();
    },
    closeRegisterPopup() {
      this.$sendMetrik('reachGoal', 'SignUp_Cancel');
      if (typeof _txq !== 'undefined') {
        _txq.push(['track', 'registration_сancel']);
      }
      this.removeBodyClass();
      this.shell.showRegisterPopup = false;
      this.shell.responseError = '';
      this.resetForm();
    },
    closeRegisterFinishPopup() {
      this.removeBodyClass();
      this.shell.showRegisterPopup = false;
      this.shell.responseError = '';
      this.resetForm();
    },
    openRegisterPopupSuccess() {
      // adRiver.trackRegistration()
      this.$sendMetrik('reachGoal', 'SignUp_SentForm_Success');
      if (typeof _txq !== 'undefined') {
        _txq.push(['track', 'registration_success']);
      }
      // this.executeAdriverEvent('signup_sentform_success');
      this.addBodyClass();
      this.shell.showRegisterPopupSuccess = true;
      this.shell.responseError = '';
    },
    closeRegisterPopupSuccess() {
      this.removeBodyClass();
      this.shell.showRegisterPopupSuccess = false;
      this.shell.responseError = '';
      this.resetForm();
    },
    openLoginFromRegisterSuccess() {
      this.shell.showRegisterPopupSuccess = false;
      this.shell.responseError = '';
      this.resetForm();
      this.addBodyClass();
      this.shell.showLoginPopup = true;
    },
    async loadFAQ() {
      try {
        const data = await fetchFAQ();
        this.faq = data.results.map(item => ({
          question: item.question,
          answer: item.answer.replace("{rules_link}", this.mainSettings.rules)
        }));
      } catch (error) {
        console.error('Error fetching FAQ:', error);
      }
    },
    validateLoginEmail() {
      const email = this.shell.email;
      
      if (!this.shell.loginFormErrors) {
        this.shell.loginFormErrors = {};
      }
      
      if (!email || email.trim() === '') {
        this.shell.loginFormErrors.email = 'Поле обязательно для заполнения';
        return;
      }
      
      // Строгая валидация email
      if (!this.isEmailStrictValid(email)) {
        this.shell.loginFormErrors.email = 'Введите корректный email';
        return;
      }
      
      // Если все проверки пройдены, очищаем ошибку
      this.shell.loginFormErrors.email = '';
    },
    validateLoginPassword() {
      const password = this.shell.password;

      if (!this.shell.loginFormErrors) {
        this.shell.loginFormErrors = {};
      }

      if (!password || password.trim() === '') {
        this.shell.loginFormErrors.password = 'Поле обязательно для заполнения';
        return;
      }

      if (password.length < 6) {
        this.shell.loginFormErrors.password = 'Пароль должен быть не менее 6 символов';
        return;
      }

      this.shell.loginFormErrors.password = '';
    },
    validateField(field) {
      switch (field) {
        case 'first_name': {
          this.shell.errors.first_name =
            registerNameSignificantLength(this.shell.registerForm.first_name) < 2
              ? 'Введите имя (минимум 2 символа)'
              : '';
          break;
        }
        case 'name': {
          if (!this.shell.questionForm.name || this.shell.questionForm.name.trim().length < 2) {
            this.shell.feedbackErrors.name = 'Введите имя (минимум 2 символа)';
          } else {
            this.shell.feedbackErrors.name = '';
          }
          break;
        }
        case 'text': {
          this.shell.feedbackErrors.text = this.shell.questionForm.text.length < 2 ? 'Поле обязательно для заполнения' : '';
          break;
        }
        case 'last_name': {
          this.shell.errors.last_name =
            registerNameSignificantLength(this.shell.registerForm.last_name) < 2
              ? 'Введите фамилию (минимум 2 символа)'
              : '';
          break;
        }
        case 'email': {
          const email = this.shell.registerForm.email;
          if (!email || email.trim() === '') {
            this.shell.errors.email = 'Поле обязательно для заполнения';
          } else if (!this.isEmailStrictValid(email)) {
            this.shell.errors.email = 'Введите корректный email';
          } else {
            this.shell.errors.email = '';
          }
          break;
        }
        case 'email_login': {
          const email = this.shell.email;
          if (!email || email.trim() === '') {
            this.shell.loginFormErrors.email = 'Поле обязательно для заполнения';
          } else if (!this.isEmailStrictValid(email)) {
            this.shell.loginFormErrors.email = 'Введите корректный email';
          } else {
            this.shell.loginFormErrors.email = '';
          }
          break;
        }
        case 'email_feedback': {
          const email = this.shell.questionForm.email;
          if (!email || email.trim() === '') {
            this.shell.feedbackErrors.email = 'Поле обязательно для заполнения';
          } else if (!this.isEmailStrictValid(email)) {
            this.shell.feedbackErrors.email = 'Введите корректный email';
          } else {
            this.shell.feedbackErrors.email = '';
          }
          break;
        }
        case 'phone_number': {
          this.shell.registerPhoneTouched = true;
          const raw = this.shell.registerForm.phone_number;
          const d = String(raw || '').replace(/\D/g, '');

          if (d.length === 0) {
            this.shell.errors.phone_number = 'Поле обязательно для заполнения';
            break;
          }
          if (isValidRussianMobilePhone(raw)) {
            this.shell.errors.phone_number = '';
            break;
          }
          this.shell.errors.phone_number = russianMobilePhoneHint();
          break;
        }
        case 'agree_rules': {
          this.shell.errors.agree_rules = !this.shell.registerForm.agree_rules ? 'Необходимо согласиться с правилами акции' : '';
          break;
        }
      }
    },
    async login() {
      try {
        this.shell.formSending = true;
        this.shell.loginFormErrors = {};
        this.shell.responseError = '';
        
        // Валидация email
        this.validateLoginEmail();
        
        // Валидация пароля
        if (!this.shell.loginFormErrors) {
          this.shell.loginFormErrors = {};
        }
        if (!this.shell.password || this.shell.password.trim() === '') {
          this.shell.loginFormErrors.password = 'Введите пароль';
        } else {
          // Очищаем ошибку пароля, если пароль валиден
          this.shell.loginFormErrors.password = '';
        }
        
        // Если есть ошибки - не отправляем запрос
        if (this.shell.loginFormErrors.email || this.shell.loginFormErrors.password) {
          this.shell.formSending = false;
          return;
        }

        await authorize(this.shell.email, this.shell.password);
        setAuthHeader();
        setTimeout(async () => {
          try {
            const userInfo = await getUserInfo();
            if (userInfo) {
              // adRiver.trackAuthorization()
              this.$sendMetrik('reachGoal', 'SignIn_SentForm_Success');
              if (typeof _txq !== 'undefined') {
                _txq.push(['track', 'enter_success']);
              }
              this.userId = userInfo.id;
              this.userUuid = userInfo.uuid;
              this.user = {
                first_name: userInfo.first_name,
                last_name_initial: (userInfo.last_name || '').charAt(0),
                email: userInfo.email,
              };
              this.shell.questionForm.name = userInfo.first_name;
              this.shell.questionForm.email = userInfo.email;
              this.closeLoginPopup();
              this.removeBodyClass();
              // this.initQrWidget();
              // this.executeDSPCounterEvent('login_success');
              setTimeout(() => {
                this.$router.push('/private');
              }, 500);
            }
          } catch (error) {
            console.error('Error fetching user info', error);
          }
          this.shell.formSending = false;
        }, 900); // 500 мс задержка

      } catch (error) {
        this.shell.formSending = false;
        if (error.response.status === 553 || error.response.status === 554) {
          this.shell.responseError = 'неверный логин или пароль';
        } else if (error.response && error.response.data) {
          this.shell.responseError = error.response.data.detail;
        }
      }
    },
    async register() {
      try {
        this.shell.formSending = true;
        const { first_name, last_name, phone_number, email, agree_rules, agree_to_advertising } = this.shell.registerForm;
        this.shell.registrationSuccessEmail = (email || '').trim();

        const formattedPhoneNumber = formatRussianMobileE164(phone_number);

        // Проверки
        this.shell.errors = {};
        if (registerNameSignificantLength(first_name) < 2) {
          this.shell.errors.first_name = 'Введите имя (минимум 2 символа)';
        }
        if (registerNameSignificantLength(last_name) < 2) {
          this.shell.errors.last_name = 'Введите фамилию (минимум 2 символа)';
        }
        if (!email || email.trim() === '') {
          this.shell.errors.email = 'Поле обязательно для заполнения';
        } else if (!this.isEmailStrictValid(email)) {
          this.shell.errors.email = 'Введите корректный email';
        }
        if (!formattedPhoneNumber) {
          this.shell.errors.phone_number = russianMobilePhoneHint();
        }
        if (!agree_rules) {
          this.shell.errors.agree_rules = 'Необходимо согласиться с правилами акции';
        }
        // Если есть ошибки - не отправляем
        if (Object.keys(this.shell.errors).length > 0) {
          this.shell.formSending = false;
          return;
        }

        // Получаем registration_params из localStorage или текущих utmParams
        let registrationParamsString = '';
        const savedParams = localStorage.getItem('registration_params');
        if (savedParams) {
          registrationParamsString = savedParams;
        } else if (Object.keys(this.utmParams).length > 0) {
          registrationParamsString = new URLSearchParams(this.utmParams).toString();
        }

        // Отправляем запрос с форматированной датой
        // registration_params должен быть строкой согласно документации API
        await register({
          first_name: (first_name || '').trim(),
          last_name: (last_name || '').trim(),
          phone_number: formattedPhoneNumber,
          email,
          registration_params: registrationParamsString || null,
          agree_to_advertising,
          is_policy: true,
          is_rules: agree_rules,
        });

        this.closeRegisterFinishPopup();
        // После регистрации не логиним автоматически — показываем стандартный попап.
        this.openRegisterPopupSuccess();
        state.ref = '';
        this.shell.formSending = false;
      } catch (error) {
        this.shell.formSending = false;
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          this.shell.responseError = formatApiErrorResponseMessage(
            errorData,
            'Произошла ошибка при регистрации'
          );
          if (errorData && typeof errorData === 'object' && !Array.isArray(errorData)) {
            const skip = new Set(['detail', 'message', 'non_field_errors']);
            Object.keys(errorData).forEach((field) => {
              if (skip.has(field) || this.shell.errors[field]) return;
              const v = errorData[field];
              this.shell.errors[field] = Array.isArray(v) ? v.join(', ') : v;
            });
          }
        } else {
          this.shell.responseError = 'Произошла ошибка при регистрации. Попробуйте позже.';
        }
      }
    },
    switchToLogin() {
      this.addBodyClass();
      this.shell.showResetPasswordSuccess = false;
      this.shell.showLoginPopup = true;
      this.shell.showRegisterPopup = false;
      this.shell.responseError = '';
    }
  },
};
</script>

<style>
/* Ваши стили */
</style>
